import { auth, db } from "@/lib/firebase";
import {
  doc, getDoc, setDoc, deleteDoc,
  serverTimestamp, updateDoc
} from "firebase/firestore";

const COLL = "events_favorited";

function assertUid(uid: string) {
  const a = auth.currentUser;
  if (!a) throw new Error("auth_required");
  if (a.uid !== uid) throw new Error("uid_mismatch");
}

async function buildFavoritePayload(eventId: string) {
  const snap = await getDoc(doc(db, "events", eventId));
  if (!snap.exists()) throw new Error("event_not_found");
  const data = snap.data();
  // Embed full event snapshot under 'event'
  return {
    eventId,
    event: {
      ...data,
      id: eventId, // ensure id inside embedded map
    },
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };
}

// Create (or refresh timestamp if already exists)
export async function favoriteEvent(uid: string, eventId: string) {
  assertUid(uid);
  const ref = doc(db, "users", uid, COLL, eventId);
  const existing = await getDoc(ref);
  if (!existing.exists()) {
    const payload = await buildFavoritePayload(eventId);
    await setDoc(ref, payload, { merge: false }); // matches create rule
  } else {
    // Option A: only bump updatedAt
    await updateDoc(ref, { updatedAt: serverTimestamp() });
    // Option B (refresh event snapshot) – uncomment if desired:
    // const payload = await buildFavoritePayload(eventId);
    // await setDoc(ref, { ...payload, createdAt: existing.data()?.createdAt }, { merge: false });
  }
}

export async function unfavoriteEvent(uid: string, eventId: string) {
  assertUid(uid);
  await deleteDoc(doc(db, "users", uid, COLL, eventId));
}

export async function addFavorite(eventId: string) {
  const u = auth.currentUser; if (!u) throw new Error("auth_required");
  return favoriteEvent(u.uid, eventId);
}

export async function removeFavorite(eventId: string) {
  const u = auth.currentUser; if (!u) throw new Error("auth_required");
  return unfavoriteEvent(u.uid, eventId);
}

export async function toggleFavorite(eventId: string, isFavorite: boolean) {
  return isFavorite ? removeFavorite(eventId) : addFavorite(eventId);
}
